import { Component } from '@angular/core';

@Component({
    templateUrl: './dashboard-help.component.html',
    standalone: false
})
export class DashboardHelpComponent{}

